document.addEventListener("DOMContentLoaded", () => {
	function onSizeSelect({ size = "Vælg størrelse", variantId, productId }) {
		if (!productId) return;

		const openSizeModalButtons = document.querySelectorAll(
			`#openSizeModalBtn--${productId}`
		);
		openSizeModalButtons.forEach(button => {
			button.innerHTML = size;
		});

		const sizeModals = document.querySelectorAll(`#sizeModal--${productId}`);
		sizeModals.forEach(sizeModal => {
			sizeModal.style.display = "none";
		});

		if (variantId) {
			const variantIdInputs = document.querySelectorAll(
				`#variantId--${productId}`
			);
			variantIdInputs.forEach(variantIdInput => {
				variantIdInput.value = variantId;
			});
		}
	}

	const getIdFromElementId = id => id.split("--")[1];

	document.addEventListener("click", event => {
		const targetId = event.target.id;

		if (targetId.includes("openSizeModalBtn")) {
			/* Open modal */
			const productId = getIdFromElementId(targetId);

			const sizeModals = Array.from(
				document.querySelectorAll(`#sizeModal--${productId}`)
			);

			sizeModals.forEach(sizeModal => {
				const selectSize = e =>
					onSizeSelect({
						size: e.target.dataset.size,
						variantId: e.target.value,
						productId,
					});
				/* Shown/hide modal width size pickers */
				const sizePickers = sizeModal.querySelectorAll("[data-size]");
				if (sizeModal.style.display === "block") {
					sizeModal.style.display = "none";
					sizePickers.forEach(picker => {
						picker.removeEventListener("click", selectSize);
					});
				} else {
					sizeModal.style.display = "block";
					sizePickers.forEach(picker => {
						picker.addEventListener("click", selectSize);
					});
				}
			});
		} else if (targetId.includes("addToCartBtn")) {
			/* Add to cart */
			const productId = getIdFromElementId(targetId);

			const variantIdInputs = Array.from(
				document.querySelectorAll(`#variantId--${productId}`)
			);

			if (variantIdInputs.some(input => !input.value)) {
				// Error
				event.preventDefault();
				alert("Vælg venligst en størrelse");
				return;
			}
			// Success
			onSizeSelect({ productId });
		}
	});
});
